import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, Scroll} from '@angular/router';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {environment} from '../../../environments/environment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {el} from 'date-fns/locale';
import {ViewportScroller} from '@angular/common';
import {FlowTypeService} from '../../../../../shared/src/lib/services/flow-type.service';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit, AfterViewInit {

    testName = 'anxiety';

    uid;

    startTextButtonText = 'Start test';
    apiUrl = environment.apiUrl;

    videoSrc = 'assets/img/animation/a_brain.webm';
    anchor = null;
    plansLoaded = null;

    constructor(
        private router: Router,
        public auth: AuthService,
        private device: DeviceDetectorService,
        private route: ActivatedRoute,
        private flowTypeService: FlowTypeService
    ) {
        // this.router.events.subscribe((event: any) => {
        //     if (event instanceof Scroll && event.anchor) {
        //         setTimeout(() => {
        //             this.anchor = event.anchor;
        //         }, 100);
        //     } else {
        //         this.anchor = null;
        //
        //     }
        // });
    }

    ngOnInit() {
        this.flowTypeService.state = '';
        if (this.device.browser.toLowerCase() === 'safari') {
            this.videoSrc = null;
        }
        this.startTextButtonText = this.auth?.userState?.trial ? 'Free trial' : 'Start test';
        this.route.fragment.subscribe((fragment) => {
            setTimeout(() => {
                if (fragment) {
                    console.log('ngOnInit', fragment);
                    this.scrollToElement('#' + fragment);
                }
            }, 100); // Delay to ensure elements are rendered
        });
    }

    ngAfterViewInit(): void {
        // Handle initial load with a hash
        setTimeout(() => {
            const fragment = this.route.snapshot.fragment;
            if (fragment) {
                console.log('ngAfterViewInit', fragment);

                this.scrollToElement('#' + fragment);
            }
        }, 100); // Delay to ensure elements are rendered
    }

    onPubLoaded() {
        if (this.anchor && this.plansLoaded) {
            this.scroll('#' + this.anchor);
        }
    }

    scrollToElement(fragment: string) {
        // this.viewportScroller.scrollToAnchor(fragment)
        this.scroll(fragment);

    }

    private scroll(query: string) {
        const targetElement = document.querySelector(query);
        if (!targetElement) {
            // window.scrollTo(80, 80);
        } else if (!this.isInViewport(targetElement)) {
            // targetElement.scrollIntoView();
        }
    }

    private isInViewport = (elem: any) => {
        const bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    goToLink(url: string) {
        window.open(url, '_blank');
    }

    void(event: any) {
        event.preventDefault();
    }

    onPlansLoaded(prop: any) {
        this.plansLoaded = true;
        this.onPubLoaded();
        // if (window.location.hash) {
        //     this.scrollToFirstInvalidControl(window.location.hash);
        // }
    }

    async goToTest() {
        return this.router.navigate(
            ['cs'],
            {
                state: {
                    name: this.testName
                }
            });
    }

    onPaymentSuccess(prop) {

        if (prop) {
            this.goToTest().then();
        }
    }
}
